module.exports = __webpack_public_path__ + "img/zlk2.f1d8d538.png";